// initial state
const state = {
  status: [
    {value: 1, label: '待执行'},
    {value: 2, label: '运行中'},
    {value: 3, label: '失败'},
    {value: 4, label: '处理结束'},
    {value: 5, label: '已取消'},
    {value: 6, label: '中断执行'},
  ],
  task_type: [
    {value: 1, label: '批量添加实习生'},
    {value: 2, label: '批量导出实习生'}, // 目前采用前端导出,此任务不会出现
    {value: 3, label: '批量修改实习生'},
    {value: 4, label: '批量导入项目出勤安排'},
    {value: 5, label: '批量修改项目出勤安排'},
  ],
}
const getters = {}
const actions = {}
const mutations = {}
export const auditCrontab = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/audit-batchjob/audit-batchjob.store.js